<template>
    <div class="Section TSEComplianceSection" id="tse-compliance">
        <div class="SectionContainer">
            <div class="TSEHeader">
                <div class="TSEBadge">
                    <i class="ri-shield-check-line"></i>
                    <span>2026 Pflicht</span>
                </div>
                <h2 class="SectionTitle">
                    <span class="TitleAccent">TSE-Konformität</span>
                    für Taxi- und Mietwagenunternehmen
                </h2>
                <p class="TSESubtitle">
                    Ab dem 1. Januar 2026 ist TSE-Konformität gesetzlich vorgeschrieben. Wir machen
                    es einfach – automatisch und zuverlässig.
                </p>
            </div>

            <div class="TSEContent">
                <div class="TSEGrid">
                    <div class="TSECard">
                        <div class="CardIcon">
                            <i class="ri-calendar-check-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Countdown bis 2026</h3>
                            <div class="Countdown">
                                <div class="CountdownItem">
                                    <span class="CountdownNumber">{{ daysUntil2026 }}</span>
                                    <span class="CountdownLabel">Tage</span>
                                </div>
                            </div>
                            <p>
                                Die Zeit drängt. Bereiten Sie sich jetzt vor, um ab Januar 2026 ohne
                                Unterbrechung weiterzuarbeiten.
                            </p>
                        </div>
                    </div>
                    <div class="TSECard">
                        <div class="CardIcon">
                            <i class="ri-error-warning-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Risiko ohne TSE</h3>
                            <div class="RiskList">
                                <div class="RiskItem">
                                    <i class="ri-close-circle-line"></i>
                                    <span>Bußgelder bis zu 25.000€</span>
                                </div>
                                <div class="RiskItem">
                                    <i class="ri-close-circle-line"></i>
                                    <span>Betriebsverbot</span>
                                </div>
                                <div class="RiskItem">
                                    <i class="ri-close-circle-line"></i>
                                    <span>Lizenzverlust</span>
                                </div>
                            </div>
                            <p>Ohne TSE-konforme Lösung riskieren Sie Ihren gesamten Betrieb.</p>
                        </div>
                    </div>

                    <div class="TSECard">
                        <div class="CardIcon">
                            <i class="ri-shield-check-line"></i>
                        </div>
                        <div class="CardContent">
                            <h3>Mit TaxiFusion TSE</h3>
                            <div class="BenefitList">
                                <div class="BenefitItem">
                                    <i class="ri-checkbox-circle-line"></i>
                                    <span>100% rechtssicher</span>
                                </div>
                                <div class="BenefitItem">
                                    <i class="ri-checkbox-circle-line"></i>
                                    <span>Automatische Konformität</span>
                                </div>
                                <div class="BenefitItem">
                                    <i class="ri-checkbox-circle-line"></i>
                                    <span>Zukunftssicher</span>
                                </div>
                            </div>
                            <p>
                                TSE-Konformität ohne zusätzlichen Aufwand für Taxi- und
                                Mietwagenunternehmen. Wir erledigen alles automatisch.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="TSECTA">
                    <h3>Bereit für TSE-Konformität?</h3>
                    <p>
                        Sichern Sie sich jetzt TSE-Konformität für Ihr Taxi- oder
                        Mietwagenunternehmen und vermeiden Sie Bußgelder. Kontaktieren Sie uns für
                        eine kostenlose Beratung.
                    </p>
                    <router-link to="/register" class="TSEButton">
                        <SiteButton>
                            <span>TSE-konform mit uns</span>
                            <i class="ri-arrow-right-line"></i>
                        </SiteButton>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SiteButton from '@/components/SiteButton';

export default {
    name: 'TSEKonformitatSection',
    components: {
        SiteButton,
    },
    computed: {
        daysUntil2026() {
            const targetDate = new Date('2026-01-01T00:00:00');
            const today = new Date();
            const diffTime = targetDate - today;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return Math.max(0, diffDays);
        },
    },
};
</script>

<style lang="scss" scoped>
.TSEComplianceSection {
    @extend %sectionWrapper;
    padding: 80px 0;

    @media (max-width: $breakpoint-tablet-portrait) {
        padding: 60px 0;
    }
}

.SectionContainer {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

.TSEHeader {
    text-align: center;
    margin-bottom: 60px;

    @media (max-width: $breakpoint-mobile) {
        text-align: left;
    }

    .TSEBadge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: linear-gradient(135deg, #b03543 0%, #d4374a 100%);
        color: white;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 0.9rem;
        font-weight: 600;
        margin-bottom: 20px;

        i {
            font-size: 16px;
        }
    }

    .SectionTitle {
        font-size: 3rem;
        font-weight: 700;
        margin: 0 0 20px;
        color: var(--color-text-black);

        .TitleAccent {
            color: #b03543;
        }

        @media (max-width: $breakpoint-tablet-portrait) {
            font-size: 2.5rem;
        }

        @media (max-width: $breakpoint-mobile) {
            font-size: 2rem;
        }
    }

    .TSESubtitle {
        font-size: 1.25rem;
        color: var(--color-text);
        max-width: 600px;
        margin: 0 auto;
        line-height: 1.6;

        @media (max-width: $breakpoint-mobile) {
            font-size: 1.125rem;
        }
    }
}

.TSEContent {
    display: flex;
    flex-direction: column;
    gap: 60px;
}

.TSEGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;

    @media (max-width: $breakpoint-tablet-portrait) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
}

.TSECard {
    background: white;
    border-radius: 16px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    border: 0.5px solid rgba(0, 0, 0, 0.05);

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    }

    .CardIcon {
        width: 60px;
        height: 60px;
        background: linear-gradient(135deg, #b03543 0%, #d4374a 100%);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        i {
            font-size: 28px;
            color: white;
        }
    }

    .CardContent {
        h3 {
            font-size: 1.5rem;
            font-weight: 600;
            margin: 0 0 20px;
            color: var(--color-text-black);
        }

        p {
            color: var(--color-text);
            line-height: 1.6;
            margin: 0;
            font-size: 0.95rem;
        }
    }
}

.Countdown {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    .CountdownItem {
        text-align: center;

        .CountdownNumber {
            display: block;
            font-size: 2.5rem;
            font-weight: 700;
            color: #b03543;
            line-height: 1;
        }

        .CountdownLabel {
            font-size: 0.9rem;
            color: var(--color-text);
            font-weight: 500;
        }
    }
}

.RiskList,
.BenefitList {
    margin-bottom: 20px;

    .RiskItem,
    .BenefitItem {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        i {
            font-size: 18px;
            flex-shrink: 0;
        }

        span {
            font-weight: 500;
        }
    }

    .RiskItem {
        i {
            color: #dc3545;
        }

        span {
            color: #dc3545;
        }
    }

    .BenefitItem {
        i {
            color: #28a745;
        }

        span {
            color: #28a745;
        }
    }
}

.TSEHardware {
    text-align: center;

    @media (max-width: $breakpoint-mobile) {
        text-align: left;
    }

    h3 {
        font-size: 2rem;
        font-weight: 600;
        margin: 0 0 30px;
        color: var(--color-text-black);
    }

    .HardwareGrid {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 40px;
        margin-bottom: 20px;
        flex-wrap: wrap;

        @media (max-width: $breakpoint-mobile) {
            gap: 20px;
        }

        .HardwareItem {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;

            .HardwareLogo {
                width: 80px;
                height: 80px;
                background: white;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
                border: 0.5px solid rgba(0, 0, 0, 0.05);

                img {
                    max-width: 60px;
                    max-height: 60px;
                    object-fit: contain;
                }
            }

            span {
                font-size: 0.9rem;
                font-weight: 500;
                color: var(--color-text);
                text-align: center;
            }
        }
    }

    .HardwareNote {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-size: 0.95rem;
        color: var(--color-text);
        background: rgba(53, 176, 119, 0.1);
        padding: 12px 20px;
        border-radius: 8px;
        margin: 0 auto;

        i {
            color: rgb(27, 123, 72);
            font-size: 16px;
        }
    }
}

.TSECTA {
    text-align: center;
    background: linear-gradient(135deg, #1d8465 0%, #07bb81 100%);
    color: white;

    @media (max-width: $breakpoint-mobile) {
        text-align: left;
    }
    padding: 40px;
    border-radius: 16px;
    box-shadow: 0 20px 40px rgba(35, 157, 116, 0.3);

    h3 {
        font-size: 2rem;
        font-weight: 600;
        margin: 0 0 15px;
        color: white;
    }

    p {
        font-size: 1.1rem;
        margin: 0 0 30px;
        opacity: 0.9;
        line-height: 1.6;
        color: white;
    }

    .TSEButton {
        text-decoration: none;
        display: inline-block;

        .SiteButton {
            background: white;
            color: var(--color-green-dark);
            border: none;
            padding: 16px 32px;
            font-size: 1.125rem;
            font-weight: 600;
            border-radius: 8px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
                background: #f0fdf4;
            }

            span {
                color: var(--color-green-dark);
            }

            i {
                color: var(--color-green-dark);
            }
        }
    }
}
</style>
